import { CSSProperties } from 'react';

export const separatorContainerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px 0',
  margin: '4px 0'
};

export const separatorTextStyle: CSSProperties = {
  color: 'rgb(149,149,149)',
  fontSize: '11px',
  fontWeight: 500,
  padding: '4px 10px',
  borderRadius: '12px',
  textAlign: 'center'
};
